import * as z from "zod";

export const editImageWithAi = {
  name: "editImageWithAi" as const,
  input: z.object({
    imageUrl: z.string().optional(),
    imageBase64: z.string().optional(),
    prompt: z.string(),
  }),
  output: z.object({ imageUrl: z.string() }),
};
